export default class Clt{
    CarteiraDeTrabalho: string;
    NumeroSerieCtps: string;
    Pis: string;
    UfCtps: string;
    constructor(){}

}
